<template>
  <!-- Page Content -->
  <div class="hero-static d-flex align-items-center">
    <div class="w-100">
      <!-- Sign In Section -->
      <div class="bg-white">
        <div class="content content-full">
          <b-row class="justify-content-center">
            <b-col md="8" lg="6" xl="4" class="py-4">
              <!-- Invalid Login -->

              <b-alert variant="danger" show dismissible v-if="error">
                <p class="mb-0">
                  {{ $t("login.form.error.auth") }}
                </p>
              </b-alert>

              <!-- Header -->
              <div class="text-center">
                <p class="mb-2">
                  <i class="fa fa-2x fa-chart-line text-primary"></i>
                </p>
                <h1 class="h4 mb-1">
                  {{ $t("title") }}
                </h1>
              </div>
              <!-- END Header -->

              <!-- Sign In Form -->
              <b-form @submit.stop.prevent="onSubmit">
                <div class="py-3">
                  <div class="form-group">
                    <b-form-input
                      size="lg"
                      class="form-control-alt"
                      id="username"
                      name="username"
                      :placeholder="$t('login.form.placeholder.username')"
                      v-model="$v.form.username.$model"
                      :state="!$v.form.username.$error && null"
                      aria-describedby="username-feedback"
                    ></b-form-input>
                  </div>
                  <div class="form-group">
                    <b-form-input
                      type="password"
                      size="lg"
                      class="form-control-alt"
                      id="password"
                      name="password"
                      :placeholder="$t('login.form.placeholder.password')"
                      v-model="$v.form.password.$model"
                      :state="!$v.form.password.$error && null"
                      aria-describedby="password-feedback"
                    ></b-form-input>
                  </div>
                </div>
                <b-row class="form-group row justify-content-center mb-0">
                  <b-col md="6" xl="5">
                    <b-button type="submit" variant="primary" block>
                      <i class="fa fa-fw fa-sign-in-alt mr-1"></i>
                      {{ $t("login.form.button") }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
              <!-- END Sign In Form -->
            </b-col>
          </b-row>
        </div>
      </div>
      <!-- END Sign In Section -->

      <!-- Footer -->
      <div class="font-size-sm text-center text-muted py-3">
        <strong>egf PCT</strong> &copy; egf - Eduard G. Fidel GmbH
      </div>
      <!-- END Footer -->
    </div>
  </div>
  <!-- END Page Content -->
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

import Login from "@/assets/js/Auth.js";

export default {
  name: "Login",
  mixins: [validationMixin],
  data() {
    return {
      form: {
        username: null,
        password: null
      },
      error: false
    };
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(3)
      },
      password: {
        required,
        minLength: minLength(5)
      }
    }
  },
  mounted() {
    let username = this.$cookies.get("user");

    if (username != "") {
      this.form.username = username;
    }
  },
  methods: {
    onSubmit() {
      this.$v.form.$touch();

      if (this.$v.form.$anyError) {
        return;
      }

      Login.login(this.form.username, this.form.password).then(result => {
        this.error = !result;

        if (typeof result === "object") {
          this.$cookies.set("user", this.form.username);
          this.$cookies.set("name", result.name);
          this.$cookies.set("role", result.role);
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
